export default "__VITE_ASSET__tOKaCzS1__"